import React from 'react'
import PropTypes from "prop-types"
import { RichText } from 'prismic-reactjs'
import { ThemeProvider } from "styled-components"

import { getLinkPropsFromReference } from '../../utils/link'
import { RichLinks, RichContent } from '../../utils/html'

import { THEME_GREY } from '../../theme/theme'
import { margin, SIZE } from '../../theme/metrics'

import PageMetaContext from '../../context/page-meta-context';

import SectionContainer from '../section-container'
import SectionHeader from '../section-header'
import ResponsiveImage from '../responsive-image'

import { Chapter, ImageContainer, ImageContent, Image, TextContainer, Text } from './story.styles'


const Story = ({label,heading,items,overlap,overlapSmall}) => {
	return (
		<ThemeProvider theme={(theme) => ({...theme,...THEME_GREY})}>
			<SectionContainer overlap={overlap} overlapSmall={overlapSmall}>
				{heading && <SectionHeader label={label} heading={heading} />}
				{items.map((item,index) => (
					<Chapter key={index}>
						<ImageContainer>
							<ImageContent>
								{item.image && <ResponsiveImage image={item.image} lazy sizes={{medium:{span:(index % 2 === 0 ? 6 : 8)}}} sizeOptions={{defaultSize:`calc(100vw - ${margin(SIZE.small,{multiplier:2})})`}} />}
							</ImageContent>
						</ImageContainer>
						<TextContainer>
							<Text><RichContent render={item.text} /></Text>
						</TextContainer>
					</Chapter>
				))}
			</SectionContainer>
		</ThemeProvider>
	)
}

export default Story;